/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AgentOwnerAssignmentForm = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  /**
   * Eligible same-organization human replacement owner
   */
  ownerUserId: string;
};

/** @internal */
export type AgentOwnerAssignmentForm$Outbound = {
  agent_id: string;
  owner_user_id: string;
};

/** @internal */
export const AgentOwnerAssignmentForm$outboundSchema: z.ZodMiniType<
  AgentOwnerAssignmentForm$Outbound,
  AgentOwnerAssignmentForm
> = z.pipe(
  z.object({
    agentId: z.string(),
    ownerUserId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      ownerUserId: "owner_user_id",
    });
  }),
);

export function agentOwnerAssignmentFormToJSON(
  agentOwnerAssignmentForm: AgentOwnerAssignmentForm,
): string {
  return JSON.stringify(
    AgentOwnerAssignmentForm$outboundSchema.parse(agentOwnerAssignmentForm),
  );
}
